











































































































































import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import PeriodPicker from '@/components/PeriodPicker';
import TotalInformationCard from '@/components/TotalInformationCard';
import {mapActions, mapGetters} from 'vuex';
import {getApartment, cancelRent, prolongRent} from '@/services/api';
import InfoBlock from '@/components/InfoBlock';
import { formMixins } from '@/components/SignUpForm/mixins';

@Component({
  name: 'ContinueEndingRent',
  components: {
    PeriodPicker,
    TotalInformationCard,
    InfoBlock,
  },
  created() {
    document.addEventListener('click', this.clickOnPage);
    this.closePage = this.$route.name === 'leaseContractClose';
    getApartment(this.$route.params.id)
        .then((response) => {
          if (response.status === 200) {
            this.actualApartment = response.data;
            this.datePicker = this.actualApartment.lease_contract.end;
          } else {
            this.$router.push({name: 'myApartments'});
          }
        })
        .catch((error) => {
          console.log(error);
        });
  },
  beforeDestroy() {
    window.removeEventListener('click', this.clickOnPage);
  },
  props: {},
  data() {
    return {
      datePicker: '',
      showDatePicker: false,
      endDate: null,
      inputDelete: '',
      closePage: false,
      actualApartment: null,
      periodValue: 1,
      showThankModal: false,
      errorMessage: '',
    };
  },
  computed: {
    ...mapGetters(['translations', 'periodPickerData', 'language']),
    ...mapGetters('profile', ['prolongCloseTexts']),
    hasError() {
      return this.errorMessage.length > 0;
    },
    actualTexts() {
      if (this.prolongCloseTexts) {
        return this.closePage ? this.prolongCloseTexts.close : this.prolongCloseTexts.prolong;
      }
    },
    infoBlock() {
      return (this as any).actualTexts?.info_block;
    },
    actualPeriod: {
      get() {
        return this.periodValue;
      },
      set(month) {
        this.periodValue = month;
      },
    },
    continueRentLimits() {
      const end = this.$dayjs(this.actualApartment.rent_ad_request.end);
      const now = this.$dayjs();
      if (!this.periodPickerData) {
        return {min: 1, max: 35};
      } else if (end.diff(now, 'month') < this.periodPickerData.limits.max) {
        return {min: 1, max: end.diff(now, 'month')};
      } else {
        return {min: 1, max: this.periodPickerData.limits.max};
      }
    },
    startDate() {
      if (this.actualApartment) {
        return this.$dayjs(this.actualApartment.lease_contract.end).add(1, 'day').format('YYYY-MM-DD');
      }
    },
  },
  methods: {
    ...mapActions(['showCentralAlert']),
    validate() {
      const valid = formMixins.rules.required(
        this.inputDelete,
        this.$store.getters.translations.field_errors.required,
      );
      if (typeof valid === 'string') {
        this.errorMessage = valid;
      }
    },
    clickOnPage(e) {
      if (this.showDatePicker
          && e.target.id !== 'date-block'
          && e.target.parentElement.id !== 'date-block'
          && !(this as any).$refs.dateBlock.contains(e.target)
          && !(this.$refs.datePickerBlock as Vue).$el.contains(e.target)) {
        this.showDatePicker = !this.showDatePicker;
      }
    },
    sendEvent() {
      this.closePage ? this.sendCloseData() : this.sendProlongData();
    },
    sendCloseData() {
      this.errorMessage = '';
      const data = {
        id: this.actualApartment.lease_contract.id,
        value: {
          date: this.datePicker,
          reason: this.inputDelete,
        },
      };
      cancelRent(data)
          .then((response) => {
            if (response.status === 200) {
              this.showThankModal = true;
            } else {
              this.errorMessage = response.data.mobile_errors[0]?.messages[0];
            }
          })
          .catch((error) => {
            console.log(error);
          });
    },
    sendProlongData() {
      this.errorMessage = '';
      const data = {
        id: this.actualApartment.lease_contract.id,
        value: {
          number_of_months: this.periodValue,
        },
      };
      prolongRent(data)
          .then((response) => {
            if (response.status === 200) {
              this.showThankModal = true;
            } else {
              const map = {
                reason: (this as any).actualTexts.reason_subtitle,
              };
              this.errorMessage = response.data.mobile_errors[0]?.messages[0];
            }
          })
          .catch((error) => {
            console.log(error);
          });
    },
    closeContinueEnding() {
      this.$router.push({name: 'myApartmentOne', params: {id: this.$route.params.id}});
    },
  },
})
export default class ContinueEndingRent extends Vue {}
